import {AfterViewInit, Component, OnInit} from '@angular/core';
import {BaseModal} from "../../../../shared/components/modal/base-modal";
import {CloseGuard, DialogRef, ModalComponent, ModalContext} from 'src/app/modules/shared/modal/ngx-modal-compat';
import {DomSanitizer, SafeResourceUrl} from "@angular/platform-browser";
import {CommonService} from "../../../../shared/services/common.service";
import {MemberService} from "../../../services/member.service";
import {ToastrService} from "ngx-toastr";
import {Router} from "@angular/router";
import {decodeHtml, partnerIdFromLogoUrl, partnerImageUrl} from "../benefit-card/benefit-card.component";

@Component({
    selector: 'app-benefit-details-popup',
    templateUrl: './benefit-details-popup.component.html',
    styleUrls: ['./benefit-details-popup.component.scss'],
    standalone: false
})
export class BenefitDetailsPopupComponent extends BaseModal implements OnInit, AfterViewInit, CloseGuard, ModalComponent<ModalContext> {

  data: any = {};
  /** Partner name as plain text, for the call-to-action label. */
  displayName = '';
  logoFailed = false;

  /**
   * The logo comes from our own cache endpoint at the width the card uses, not
   * from Voyado's full-size file: about 160 kB there against the 176 px copy the
   * card already holds (WO-16 left this one behind). The box here is wider than
   * the card's, so that copy is upscaled on a 2x screen; FIND-19 holds the
   * trade-off.
   */
  logoUrl: string | null = null;
  private logoFellBack = false;

  constructor(public dialog: DialogRef<ModalContext>,
              public commonService: CommonService,
              public memberService: MemberService,
              private toastr: ToastrService,
              private router: Router,
              public sanitizer: DomSanitizer,
  ) {
    super();
    const cntx: any = this.dialog.context;
    this.data = cntx.data
    this.displayName = decodeHtml(this.data?.name);

    const partnerId = partnerIdFromLogoUrl(this.data?.urlLogo);
    this.logoUrl = partnerId ? partnerImageUrl(partnerId, 'logo') : this.directLogo();
    // A logo outside Voyado is already on its own URL: nothing to fall back to.
    this.logoFellBack = !partnerId;
  }

  /** Tries Voyado directly once when our endpoint fails, then drops the logo. */
  onLogoError(): void {
    if (!this.logoFellBack) {
      this.logoFellBack = true;
      const direct = this.directLogo();
      if (direct && direct !== this.logoUrl) {
        this.logoUrl = direct;
        return;
      }
    }
    this.logoFailed = true;
  }

  private directLogo(): string | null {
    return typeof this.data?.urlLogo === 'string' && this.data.urlLogo ? this.data.urlLogo : null;
  }

  /**
   * The field carries HTML, and an "empty" one often arrives as <p>&nbsp;</p>
   * or a lone <br>, so tags and non-breaking spaces come out before the test.
   */
  get hasBenefitText(): boolean {
    const raw = this.data?.benefit;
    if (typeof raw !== 'string') {
      return false;
    }
    return raw.replace(/<[^>]*>/g, ' ').replace(/&nbsp;/gi, ' ').replace(/ /g, ' ').trim().length > 0;
  }

  ngOnInit(): void {
    super.ngOnInit();

  }

  ngAfterViewInit() {
    super.ngAfterViewInit();
  }

  closeModal(result: any) {
    // this.router.navigateByUrl('/manage-card/add-card-ok');
    this.close(result);
  }

  beforeDismiss(): boolean {
    return true;
  }

  beforeClose(): boolean {
    return true;
  }
}
